export const MODAL_SHOW_ACTION = 'MODAL_SHOW_ACTION';
export const MODAL_HIDE_ACTION = 'MODAL_HIDE_ACTION';
export const MODAL_UPDATE_ACTION = 'MODAL_UPDATE_ACTION';
// TOP表示
export const MODAL_TYPE_TOP_VIDEO = 'MODAL_TYPE_TOP_VIDEO';
// PDF表示
export const MODAL_TYPE_PDF_VIEW_IMAGE = 'MODAL_TYPE_PDF_VIEW_IMAGE';
// 検索画面
export const MODAL_TYPE_SEARCH_TAG_FILTER = 'MODAL_TYPE_SEARCH_TAG_FILTER';
export const MODAL_TYPE_SEND_PICKUP_COMPLETE = 'MODAL_TYPE_SEND_PICKUP_COMPLETE';
// プロジェクト事例詳細
export const MODAL_TYPE_SOLUTION_VIDEO = 'MODAL_TYPE_SOLUTION_VIDEO';
// プロジェクト事例登録・編集
export const MODAL_TYPE_SOLUTION_ADD = 'MODAL_TYPE_SOLUTION_ADD';
export const MODAL_TYPE_SOLUTION_EDIT = 'MODAL_TYPE_SOLUTION_EDIT';
// コンサルタントマイページ
export const MODAL_TYPE_PRO_MYPAGE_REPRESENTATIVE = 'MODAL_TYPE_PRO_MYPAGE_REPRESENTATIVE';
export const MODAL_TYPE_PRO_MYPAGE_DESTINATION = 'MODAL_TYPE_PRO_MYPAGE_DESTINATION';
export const MODAL_TYPE_PRO_MYPAGE_DELETE = 'MODAL_TYPE_PRO_MYPAGE_DELETE';
export const MODAL_TYPE_PRO_MYPAGE_CLIENT = 'MODAL_TYPE_PRO_MYPAGE_CLIENT';
export const MODAL_TYPE_PRO_MYPAGE_REPLY = 'MODAL_TYPE_PRO_MYPAGE_REPLY';
export const MODAL_TYPE_PRO_MYPAGE_STAFF = 'MODAL_TYPE_PRO_MYPAGE_STAFF';
export const MODAL_TYPE_PRO_MYPAGE_ORDER = 'MODAL_TYPE_PRO_MYPAGE_ORDER';
export const MODAL_TYPE_PRO_MYPAGE_SEND_OFF = 'MODAL_TYPE_PRO_MYPAGE_SEND_OFF';
export const MODAL_TYPE_PRO_MYPAGE_REVIEW = 'MODAL_TYPE_PRO_MYPAGE_REVIEW';
// コンサルタントプロフィール
export const MODAL_TYPE_INQUIRY_TO_CONSULTANT = 'MODAL_TYPE_INQUIRY_TO_CONSULTANT';
// クライアントマイページ
export const MODAL_TYPE_CLIENT_MYPAGE_RFP_ORDER = 'MODAL_TYPE_CLIENT_MYPAGE_RFP_ORDER';
export const MODAL_TYPE_CLIENT_MYPAGE_RFP_SEND_OFF = 'MODAL_TYPE_CLIENT_MYPAGE_RFP_SEND_OFF';
export const MODAL_TYPE_CLIENT_MYPAGE_ORDER = 'MODAL_TYPE_CLIENT_MYPAGE_ORDER';
export const MODAL_TYPE_CLIENT_MYPAGE_SEND_OFF = 'MODAL_TYPE_CLIENT_MYPAGE_SEND_OFF';
export const MODAL_TYPE_CLIENT_MYPAGE_CONSIDERATION = 'MODAL_TYPE_CLIENT_MYPAGE_CONSIDERATION';
export const MODAL_TYPE_CLIENT_MYPAGE_REVIEW = 'MODAL_TYPE_CLIENT_MYPAGE_REVIEW';
export const MODAL_TYPE_CLIENT_CREATE_BOARD = 'MODAL_TYPE_CLIENT_CREATE_BOARD';
// アラート
export const MODAL_TYPE_LOGIN_REQUIRED = 'MODAL_TYPE_LOGIN_REQUIRED';
export const MODAL_TYPE_CONSULTANT_ALERT = 'MODAL_TYPE_CONSULTANT_ALERT';
export const MODAL_TYPE_CLIENT_EXAMINATION_ALERT = 'MODAL_TYPE_CLIENT_EXAMINATION_ALERT';
/**
 * actionに応じた共通の値を返す
 * @param action
 * @param modalType
 * @param id
 * @param item
 * @param modalId
 * @returns {{modalType: *, payload: {item: {}, modalId: null, id: null}, type: *}|{modalType, payload: {item: {}, modalId: null}, type}}
 */
const setModal = (action, modalType, id = null, item = {}, modalId = null) => {
    const actions = {
        modalType,
        payload: {
            item,
            modalId,
        },
        type: action,
    };
    if (id) {
        return Object.assign(Object.assign({}, actions), { payload: Object.assign(Object.assign({}, actions.payload), { id }) });
    }
    return actions;
};
/**
 * モーダル表示
 * @param modalType
 * @param id
 * @param item
 * @param modalId
 * @returns {{modalType: *, payload: {item: {}, modalId: null, id: null}, type: *}|{modalType, payload: {item: {}, modalId: null}, type}}
 */
export const showModal = (modalType, id = null, item = {}, modalId = null) => setModal(MODAL_SHOW_ACTION, modalType, id, item, modalId);
/**
 * モーダル非表示
 * @param modalType
 * @param id
 * @param modalId
 * @returns {{modalType, type: string}|{modalType, payload: {id: null}, type: string}}
 */
export const hideModal = (modalType, id = null, modalId = null) => ({
    modalType,
    payload: {
        id,
        modalId,
    },
    type: MODAL_HIDE_ACTION,
});
/**
 * モーダルの表示状態を変えず、値だけ更新する
 * @param modalType
 * @param id
 * @param item
 * @param modalId
 * @returns {{modalType: *, payload: {item: {}, modalId: null, id: null}, type: *}|{modalType, payload: {item: {}, modalId: null}, type}}
 */
export const updateModal = (modalType, id = null, item = {}, modalId = null) => setModal(MODAL_UPDATE_ACTION, modalType, id, item, modalId);
